var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Api, JsonRpc } from 'eosjs';
import { Keycat } from 'keycatjs';
function logIfDebugEnabled(msg) {
    var debug = localStorage.getItem('DEBUG');
    if (debug === 'true') {
        console.log('IN WALLET: ' + msg);
    }
}
export function keycatWalletProvider() {
    return function makeWalletProvider(network) {
        var account;
        var publicKey;
        var chainId = network.chainId;
        // This is a temporary solution, will be cleaned up so that any chanin can be used.  
        var keycatNetwork = '';
        if (chainId === 'aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906') {
            keycatNetwork = 'main';
        }
        else if (chainId === 'cf057bbfb72640471fd910bcb67639c22df9f92470936cddc1ade0e2f2e7dc4f') {
            keycatNetwork = 'jungle';
        }
        else {
            keycatNetwork = 'custom';
        }
        var nodeUrl = network.protocol + "://" + network.host + ":" + network.port;
        var keycat = new Keycat({
            blockchain: {
                name: 'eos',
                //@ts-ignore
                network: keycatNetwork,
                nodes: keycatNetwork === 'custom' ? [nodeUrl] : null,
            }
        });
        function connect(appName) {
            logIfDebugEnabled('The connect method of myWallet was called');
            return Promise.resolve(true);
        }
        function discover(discoveryOptions) {
            logIfDebugEnabled('The discover() method of myWallet was called');
            return new Promise(function (resolve) {
                var discoveryInfo = {
                    keys: [],
                    note: 'Keycat wallet does not support discovery'
                };
                resolve(discoveryInfo);
            });
        }
        function disconnect() {
            return Promise.resolve(true);
        }
        // Authentication
        function login(accountName) {
            return __awaiter(this, void 0, void 0, function () {
                var auth;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            logIfDebugEnabled('The login method of myWallet was called');
                            return [4 /*yield*/, keycat.signin()];
                        case 1:
                            auth = _a.sent();
                            publicKey = auth.publicKey;
                            account = auth.accountName;
                            return [2 /*return*/, auth];
                    }
                });
            });
        }
        function logout(accountName) {
            publicKey = null;
            account = null;
            return Promise.resolve(true);
        }
        var walletProvider = {
            id: 'Keycat',
            meta: {
                name: 'Keycat',
                shortName: 'Keycat',
                description: 'Keycat - A wallet in your browser'
            },
            signatureProvider: {
                getAvailableKeys: function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var arr;
                        return __generator(this, function (_a) {
                            if (!publicKey) {
                                throw new Error('Cannot use signature provider when you are not logged-in');
                            }
                            logIfDebugEnabled('In getAvailableKeys');
                            logIfDebugEnabled('Return Key: ' + publicKey);
                            arr = [publicKey];
                            return [2 /*return*/, arr];
                        });
                    });
                },
                sign: function (signatureProviderArgs, reason) {
                    return __awaiter(this, void 0, void 0, function () {
                        var rpcUrl, api, tx, sigresult;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    logIfDebugEnabled('In Sign');
                                    rpcUrl = network.protocol + "://" + network.host + ":" + network.port;
                                    api = new Api({
                                        rpc: new JsonRpc(rpcUrl),
                                        signatureProvider: this,
                                    });
                                    return [4 /*yield*/, api.deserializeTransactionWithActions(signatureProviderArgs.serializedTransaction)];
                                case 1:
                                    tx = _a.sent();
                                    return [4 /*yield*/, keycat.account(account).signTransaction(tx)];
                                case 2:
                                    sigresult = _a.sent();
                                    return [2 /*return*/, sigresult];
                            }
                        });
                    });
                }
            },
            connect: connect,
            discover: discover,
            disconnect: disconnect,
            login: login,
            logout: logout,
            signArbitrary: function signArbitrary(data, userMessage) {
                return keycat.account(account).signArbitraryData(data);
            }
        };
        return walletProvider;
    };
}
export default keycatWalletProvider;
//# sourceMappingURL=index.js.map